import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

export const ET_ZONE = "America/New_York";

export function nowET() {
    return dayjs().tz(ET_ZONE);
}

export function todayETDate() {
    return nowET().format("YYYY-MM-DD");
}

/** Format a UTC ISO or Date into `YYYY-MM-DD HH:mm:ss ET`. */
export function fmtET(input, opts = {}) {
    if (!input) return "—";
    const d = dayjs.utc(input).tz(ET_ZONE);
    if (!d.isValid()) return "—";
    if (opts.dateOnly) return d.format("YYYY-MM-DD") + " ET";
    if (opts.timeOnly) return d.format("HH:mm:ss") + " ET";
    return d.format("YYYY-MM-DD HH:mm:ss") + " ET";
}

export function fmtETShort(input) {
    if (!input) return "—";
    const d = dayjs.utc(input).tz(ET_ZONE);
    return d.format("MM-DD HH:mm:ss") + " ET";
}

export function utcNowISO() {
    return dayjs.utc().toISOString();
}

export { dayjs };
